export default function PoAddressIssuesBanner({ issues = [] }) {
  if (!issues.length) return null;
  return <section role="status" aria-live="polite" style={{
    border: "2px solid #b42318", borderRadius: 10, background: "#fff4f2",
    padding: "18px 20px", marginBottom: 20, color: "#7a271a", lineHeight: 1.6,
  }}>
    <h3 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 10px", color: "#b42318" }}>
      Shipping address needs review
    </h3>
    <ul style={{ paddingLeft: 22, margin: "0 0 12px" }}>
      {issues.map(issue => <li key={issue.code}>{issue.message}</li>)}
    </ul>
    <p style={{ margin: 0 }}>Compare these fields with the original PDF's SHIP TO address and resolve any issues before shipping. This is a format check, not confirmation that the address is deliverable.</p>
  </section>;
}
